<template>
  <div v-if="section">
    <h1 class="text-center" v-text="section.title"></h1>
    <v-row>
      <p v-html="section.desc"></p>
    </v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="12"
      v-for="(block, index) in section.blocks"
      :key="index"
    >
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-row v-if="block && block.images && block.images.length > 0">
            <carousel-image
              :slides="getImageUrls(block.images)"
              :height="height"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <h2 v-text="block.title"></h2>
          <v-row>
            <p :ref="'block_content_id' + index" v-html="block.content"></p>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import CarouselImage from "@/views/home/page/CarouselImage.vue";

@Component({
  name: "HalfImage",
  components: { CarouselImage },
  props: {
    section: {
      default: null,
    },
  },
})
export default class HalfImage extends Vue {
  images = [];
  height = null;
  getImageUrls(images) {
    const urls = [];
    if (images && images.length > 0) {
      for (let i = 0; i < images.length; i++) {
        if (images[i] && images[i].url) {
          urls.push(images[i].url);
        }
      }
    }
    return urls;
  }

//   async mounted() {
//     this.matchHeight();
//   }

//   matchHeight() {
//     this.height = this.$refs.block_content_id0.clientHeight;
//   }
}
</script>
